<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-22 13:32:07
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 14:07:04
 * @FilePath: /privacy-web/src/views/PrivacyProtect/ScienceIntegrity.vue
-->
<template>
  <div
    class="Science-integrity-main"
    :class="{ 'Science-integrity-main-mobile': isMobile }"
  >
    <Base-title title="我们用创新科技守护您的隐私"></Base-title>
    <div class="Science-integrity-main-content">
      <ScienceIntegrityItem
        v-for="item in dataList"
        :key="item.id"
        :data="item"
      ></ScienceIntegrityItem>
    </div>
  </div>
</template>
<script>
export default {
  // 科学守护
  name: "ScienceIntegrity",
  data() {
    return {
      dataList: [
        {
          title: "数据最小化",
          id: 1,
          content:
            "我们始终秉持数据最小化理念，并将此理念嵌入产品和系统的隐私设计中，在数据收集、数据处理和数据共享中严格遵循业务目的与数据最小化的映射关系，仅根据授权与第三方合法共享您的个人信息，致力为您提供最安全舒适的服务体验。",
        },
        {
          title: "算法赋能",
          id: 2,
          content:
            "贝壳运用先进算法技术对隐私数据进行全链路加密处理，科技与法律结合，算法赋能隐私计算。",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.Science-integrity-main {
  position: relative;
  display: flex;
  align-items: center;
  padding-top: calc($multiple * 71px);
  width: calc($multiple * 1040px);
  margin: auto;
  height: calc($multiple * 567px);
  flex-direction: column;
  background-size: 100%;
  .Science-integrity-main-content {
    display: flex;
    margin-top: calc($multiple * 62px);
  }
}
.Science-integrity-main-mobile {
  padding: 2.1rem 0;
  width: auto;
  height: auto;
  /* background: url('~assets/images/privacyProtect/位图2.png') no-repeat; */
  background-size: cover;
  .Science-integrity-main-content {
    flex-direction: column;
    margin-top: 0.82rem;
  }
}
</style>
